import { FC, RefObject, useState } from 'react';
import { Skill } from '../../models/Skill';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import SingleUnitSkillDialog from './SingleUnitSkillDialog';
import SingleUnitProgressBar from './SingleUnitProgressBar';
import { progressBarSingleUnit } from '../../businessLogicService/progressBarAssignValues';
import { UsersBySkillResults } from '../../models/UsersBySkillResults';
import { ProgressBarParent } from '../../models/ProgressBar';
import { Button } from 'primereact/button';
import { TieredMenu } from 'primereact/tieredmenu';
import { MenuItem } from 'primereact/menuitem';
import SingleUnitStandardBadges from './SingleUnitStandardBadges';
interface Props {
  skills: Skill[];
  tieredMenuRef: RefObject<TieredMenu>;
  setItemsTieredMenu: (i: MenuItem[]) => void;
  selectedStandardIds?: string[];
}

const SingleUnitDataTable: FC<Props> = ({ skills, tieredMenuRef, setItemsTieredMenu, selectedStandardIds }) => {
  const filters: DataTableFilterMeta = {
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  const [visible, setVisible] = useState<boolean>(false);
  const [skill, setSkill] = useState<Skill>();

  const nameBodyTemplate = (skill: Skill) => {
    return (
      <Button
        link
        onClick={() => {
          setSkill(skill);
          setVisible(true);
        }}
      >
        {skill.name} ({skill.code})
        {skill.lessonNumbers?.length ? (
          <h6 className="nc_unit-lessons pl-2">Lessons: {skill.lessonNumbers.map(el => el).join(', ')}</h6>
        ) : (
          <></>
        )}
      </Button>
    );
  };

  const standardBodyTemplate = (skill: Skill) => {
    return <SingleUnitStandardBadges standards={skill.standards} selectedStandardIds={selectedStandardIds} />;
  };

  const progressBarTemplate = (skill: Skill) => {
    if (skill.usersBySkillResults) {
      const values = progressBarSingleUnit(skill.usersBySkillResults as UsersBySkillResults[]);
      return (
        <SingleUnitProgressBar
          values={values}
          parent={ProgressBarParent.SINGLE_UNIT}
          tieredMenuRef={tieredMenuRef}
          setItemsTieredMenu={setItemsTieredMenu}
        />
      );
    }
  };

  return (
    <>
      <DataTable
        filters={filters}
        filterDisplay="row"
        stripedRows
        paginator
        value={skills}
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        scrollable
        scrollHeight="600px"
        className="w-full flex flex-column justify-content-center nc_unit-skill-accordion"
      >
        <Column
          body={nameBodyTemplate}
          header="Name"
          filterField="name"
          filter
          field="name"
          filterPlaceholder="Search by name"
          sortable
        ></Column>
        <Column body={progressBarTemplate}></Column>
        <Column body={standardBodyTemplate} header="Standard" field="Standard"></Column>
      </DataTable>
      {visible && skill && <SingleUnitSkillDialog visible={visible} setVisible={setVisible} skill={skill} />}
    </>
  );
};

export default SingleUnitDataTable;
